import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import styles from '../css/comuns/TelefoniaBanner.module.css';
import { config } from '../../data';

const TelefoniaBanner = () => {
  const texts = config.texts.telefoniaBanner;
  const image = config.images.telefoniaBanner.img1;

  return (
    <div className={styles['banner-container']} id="Telefonia">
      <img src={image} alt="Banner Oni Telecom" className={styles['banner-image']} />
      <div className={styles['overlay-content']}>
        <div className={styles['card-custom']}>
          <h3 className={styles['card-title']}>{texts.card1.titulo}</h3>
          <p className={styles['card-text']}>
            {texts.card1.descricao}
          </p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={config.links.external.recarga}
            className={`${styles['btn-custom']} ${styles['btn-primary']}`}
          >
            <FontAwesomeIcon icon={faMobileAlt} className={styles['icon']} /> {texts.card1.botao}
          </a>
        </div>
        <div className={styles['card-custom']}>
          <h3 className={styles['card-title']}>{texts.card2.titulo}</h3>
          <p className={styles['card-text']}>
            {texts.card2.descricao}
          </p>
          <a
            href={config.links.routes.telefonia}
            className={`${styles['btn-custom']} ${styles['btn-secondary']}`}
          >
            <FontAwesomeIcon icon={faInfoCircle} className={styles['icon']} /> {texts.card2.botao}
          </a>
        </div>
      </div>
    </div>
  );
};

export default TelefoniaBanner;